(function(runtime) {
    var _ = runtime.components.dependencies._;
    var $ = runtime.components.dependencies.jQuery.v1_11;

    var constants = runtime.components.constants.merge({
        label: {
            selectors: {
                label: '.ixp-text',
                labelContainer: '.ixp-component-form-field-label-container'
            }
        },

        choiceGroup: {
            params: {
                multiselect: 'multiselect'
            },
            selectors: {
                descendant: '.ixp-component-choice-group',
            },
            css: {
                selectModePrefix: 'ixp-component-choice-group-select-mode-'
            },
            selectModes: {
                single: 'single',
                multiple: 'multi'
            }
        },

        questionField: {
            selectors: {
                descendant: '.ixp-component-question-field[' + runtime.components.constants.components.data.componentRoot + ']',
                container: '.ixp-container',
                formField: '.ixp-component-form-field',
                inputContainer: '.ixp-component-form-field-input-container',
                input: '.ixp-input-validate'
            },
            content: {
                defaultLabel: 'Define your question type in the Page Editor',
                confirmationMessage: 'Are you sure you want to switch the question type? You will lose the previous work.'
            },
            params: {
                questionType: 'questionType'
            },
            questionTypes: {
                none: 'none',
                singleChoice: 'singleChoice',
                multipleChoice: 'multipleChoice',
                slider: 'slider',
                dropdown: 'dropdown',
                openField: 'openField'
            },
            data: {
                questionType: 'data-ixp-component-field-question-type'
            }
        }
     });

    runtime.components.registerExtensibility('ixp-question-field', {
        commands: constants.extensibility.commands || {},
        events: constants.extensibility.events || {}
    });   

    var statics = {
        getScaffolding: function(scaffoldingKey, builder, options) {
            var elementId = builder.PendingContainerChildId + new Date().getTime();
            var container = builder.scaffoldContainer('Question Field Container');

            var formField = builder.scaffold('ixp-form-field', 'Form Field');
            var labelContainer = statics.getLabelContainerScaffolding(constants.questionField.content.defaultLabel, builder, elementId);
            var inputContainer = builder.scaffoldContainer('Form Field');

            inputContainer.elementId = elementId + 'Input';
            inputContainer.scaffoldContainerParameterId = 'input_container';

            formField.content.scaffolding = [labelContainer, inputContainer];
            container.content.scaffolding = [formField];

            return {
                scaffolding: [container]
            }
        },

        getQuestionTypeScaffolding: function(builder, questionType) {
            var scaffoldingKey = 'question-field';
            var scaffoldingBuilder = {};

            scaffoldingBuilder[constants.questionField.questionTypes.singleChoice] = this._getChoiceGroupScaffolding;
            scaffoldingBuilder[constants.questionField.questionTypes.multipleChoice] = this._getChoiceGroupScaffolding;
            scaffoldingBuilder[constants.questionField.questionTypes.dropdown] = this._getDropDownScaffolding;
            scaffoldingBuilder[constants.questionField.questionTypes.openField] = this._getOpenFieldScaffolding;

            var scaffolding = scaffoldingBuilder[questionType];

            if (!scaffolding) return null;

            return scaffolding.call(this, scaffoldingKey, builder, {});
        },

        getLabelContainerScaffolding: function(content, builder, elementId) {
            var labelContainer = builder.scaffoldContainer('Label Container');
            var elementId = elementId || builder.PendingContainerChildId + new Date().getTime();

            labelContainer.elementId = elementId + 'Label';
            labelContainer.scaffoldContainerParameterId = 'label_container';
            labelContainer.content.scaffolding = [builder.scaffoldText(content, 'Label')];

            return labelContainer;
        },

        intersection: function (a, b) {
            a = a || [];
            b = b || [];

            return b.filter(function (item) {
                return a.includes(item);
            });
        },

        isChoiceGroup: function (questionType) {
            var multipleChoice = constants.questionField.questionTypes.multipleChoice;
            var singleChoice = constants.questionField.questionTypes.singleChoice;

            return questionType === multipleChoice || questionType === singleChoice;
        },

        _getChoiceGroupScaffolding: function(scaffoldingKey, builder, options) {
            var group = builder.scaffold('ixp-choice-group', 'Choice Group');

            group.style.customClass = builder.getDefaultThemes({ 'choicegroup': '', 'choicegroup-layout': 'ixp-component-choice-group-inline' })

            return group;
        },

        _getDropDownScaffolding: function(scaffoldingKey, builder, options) {
            return builder.scaffold('ixp-dropdown');
        },

        _getOpenFieldScaffolding: function(scaffoldingKey, builder, options) {
            return builder.scaffold('ixp-textbox');
        }
    };

    runtime.components.register('ixp-question-field', {
        initialize: function () {
            this.$elInputContainer = this.$el.find(constants.questionField.selectors.inputContainer);
        },

        studioInitialize: function () {
            this._makeFormFieldsHidden();
        },

        allowedDropTargets: function() {
            return ['ixp-form'];
        },

        disallowedChildrenTypes: function() {
            return ['ixp-question-field', 'ixp-form', 'ixp-form-field'];
        },

        onGetScaffolding: function(scaffoldingKey, builder, options) {
            return statics.getScaffolding(scaffoldingKey, builder, options);
        },

        getParamMapOverrides: function() {
            return {
                questionType: function(value) {
                    this._setQuestionType(value);

                    if (this.skipParamMapOverrides) {
                        this.skipParamMapOverrides = false;

                        return;
                    }

                    var isChoiceGroupSwitch = this._isChoiceGroupSwitch();
                    var isDefaultState = this._isDefaultState();

                    if (!isChoiceGroupSwitch && !isDefaultState) {
                        var confirmChange = window.confirm(constants.questionField.content.confirmationMessage);

                        if (!confirmChange) {
                            this.skipParamMapOverrides = true;
                            this.saveParameter(
                                constants.questionField.params.questionType,
                                this.previousQuestionType
                            );

                            return;
                        }
                    }

                    if (value === constants.questionField.questionTypes.none) {
                        this._setDefaultState();

                        return;
                    }

                    this._performElementsOperation();
                }
            }
        },

        onListenToStudioEvents: function(events) {
            events.on('container:children:changed', function(e) {
                if (e && e.source && this.$elInputContainer.find('#' + e.source).addBack('#' + e.source).length) {
                    this._makeFormFieldsHidden();

                    if (this._isChoiceGroupType()) {
                        this._switchChoiceGroupType();
                    }

                    const inputs = this._getInputs();

                    if (!this.deleteInProgress && !inputs.length) {
                        this._setDefaultState(true);
                    }

                    this.deleteInProgress = false;
                }
            }, this);
        },

        _setDefaultState: function (updateType) {
            this._deleteInputElements();
            this._updateLabel(constants.questionField.content.defaultLabel);

            if (!updateType) return;

            this.saveParameter(
                constants.questionField.params.questionType,
                constants.questionField.questionTypes.none
            );
        },

        _makeFormFieldsHidden: function() {
            var formFields = this.filterChildren(
                constants.questionField.selectors.formField,
                constants.questionField.selectors.descendant
            );

            formFields.attr(constants.components.studio.data.passthrough, false);
        },

        _setQuestionType: function(value) {
            if (this.questionType) {
                this.previousQuestionType = this.questionType;
            }

            this.questionType = value;
            this.$elInputContainer = this.$el.find(constants.questionField.selectors.inputContainer);
        },

        _updateLabel: function(value) {
            var label = this._getLabelContainer();

            if (!label) return;

            this.updateChildrenContent(label, {
                text: value || 'Label',
                isHtml: true
            });
        },

        _getLabelContainer: function() {
            return this.filterChildren(
                constants.label.selectors.label,
                constants.questionField.selectors.descendant
            )[0];
        },

        _getInputContainer: function() {
            var inputContainer = this.filterChildren(
                constants.questionField.selectors.inputContainer,
                constants.questionField.selectors.descendant
            );

            if (!inputContainer) return null;

            return inputContainer[0];
        },

        _getInputs: function() {
            var inputs = this.filterChildren(
                constants.questionField.selectors.input,
                constants.questionField.selectors.descendant
            );

            return inputs;
        },

        _performElementsOperation: function () {
            var isChoiceGroupSwitch = this._isChoiceGroupSwitch();

            if (isChoiceGroupSwitch) {
                this._switchChoiceGroupType();

                return;
            }

            this._deleteInputElements();

            _.defer((function () {
                var inputContainer = this._getInputContainer();
                var context = {
                    element: statics.getQuestionTypeScaffolding(this.getBuilder(), this.questionType)
                };

                this.addChildren(
                    inputContainer,
                    context,
                    this._onChildrenAdded.bind(this)
                );
            }).bind(this));
        },

        _onChildrenAdded: function() {
            var noneType = constants.questionField.questionTypes.none;

            if (this.previousQuestionType === noneType) {
                this._updateLabel();
            }
        },

        _isChoiceGroupType: function() {
            var multipleChoice = constants.questionField.questionTypes.multipleChoice;
            var singleChoice = constants.questionField.questionTypes.singleChoice;

            return this.questionType === multipleChoice || this.questionType === singleChoice;
        },

        _isChoiceGroupSwitch: function () {
            var multipleChoice = constants.questionField.questionTypes.multipleChoice;
            var singleChoice = constants.questionField.questionTypes.singleChoice;
            var choiceGroupOptions = [multipleChoice, singleChoice];

            var intersection = statics.intersection(
                [this.previousQuestionType, this.questionType],
                choiceGroupOptions
            );

            return intersection.length === choiceGroupOptions.length;
        },

        _isDefaultState: function() {
            if (this.previousQuestionType === constants.questionField.questionTypes.none) {
                return true;
            }

            var labelElement = this._getLabelContainer();

            if (!labelElement) return false;

            var content = labelElement.textContent.trim();

            return content === constants.questionField.content.defaultLabel;
        },

        _switchChoiceGroupType: function () {
            var choiceGroup = this.filterChildren(
                constants.choiceGroup.selectors.descendant,
                constants.questionField.selectors.descendant
            )[0];

            if (!choiceGroup) return;

            var singleChoice = constants.questionField.questionTypes.singleChoice;
            var componentId = $(choiceGroup).attr('data-ixp-behavior-scope-owner');
            var component = this.studioApp.componentsManager.components.getInstance(componentId);

            if (!component) return;

            var value = this.questionType === singleChoice ? 'false' : 'true';

            return component.instance.saveParameter(
                constants.choiceGroup.params.multiselect,
                value
            );
        },

        _deleteInputElements: function () {
            var childrens = this._getInputs();

            this.deleteInProgress = true;

            childrens.each((function (index, element) {
                this.removeChildren(element);
            }).bind(this));
        }
    });
})(window.ixp.runtime);
